import React from "react";
import clsx from "clsx";

import { SimpleListItemProps } from "./SimpleListItem.types";
import { useStyles } from "./SimpleListItem.styles";

function SimpleListItem(props: SimpleListItemProps) {
  const {
    children,
    bullet,
    className,
    contentClassName: contentClassNameProp,
    onClick,
    icon,
    size,
  } = props;

  const classes = useStyles(props);

  const rootClassName = clsx(className, classes.root, {
    [classes.rootBullet]: bullet,
    [classes.sizeSmall]: size === "small",
    [classes.sizeLarge]: size === "large",
  });

  const contentClassName = clsx(contentClassNameProp, classes.content);

  return (
    <li className={rootClassName} onClick={onClick} tabIndex={onClick ? 0 : -1}>
      <div className={contentClassName}>{children}</div>
      {icon && <div className={classes.icon}>{icon}</div>}
    </li>
  );
}

export default SimpleListItem;
